"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRoleFromAPI = parseRoleFromAPI;
exports.parseSection = parseSection;
exports.parseSections = parseSections;
function parseRoleFromAPI(roleRes) {
    return {
        id: roleRes.ID,
        name: roleRes.Name,
        isRoleSection: roleRes.IsRoleSection,
        color: roleRes.Color || undefined,
        requiredWeekdayNumbers: parseWeekdayNumbers(roleRes.DayNumbers),
        employeesData: parseEmployeesData(roleRes.EmployeeIds, roleRes.vEmployees, roleRes.vUnjoined),
        employeesOrder: roleRes.EmployeeIds,
        sections: parseSections(roleRes.Sections),
        roleSections: parseSections(roleRes.RoleSections),
        isGroupWide: roleRes.GroupWide,
        purpose: roleRes.Purpose,
        from: roleRes.From,
        to: roleRes.To,
        rest: roleRes.Rest,
        wage: roleRes.Wage,
        isNightShift: roleRes.IsNightShift,
        nextDayOff: roleRes.NextDayOff,
        showCount: roleRes.ShowCount,
        showStaffCount: roleRes.ShowStaffCount,
        slotType: roleRes.SlotType,
        kotHolidayType: roleRes.KOTHolidayType || "",
        externalID: roleRes.ExternalID,
        isHiddenInShiftPage: roleRes.IsHiddenInShiftPage,
        isDisabledWhenFull: roleRes.IsDisabledWhenFull,
        type: roleRes.Type || 0,
        employeePriority: roleRes.EmployeePriority,
        evenly: roleRes.Evenly,
        workEvenly: roleRes.WorkEvenly,
    };
}
function parseWeekdayNumbers(dayNumbers) {
    const out = [0, 0, 0, 0, 0, 0, 0, ''];
    dayNumbers?.forEach((d, i) => {
        if (d === '') {
            out[i] = d;
            return;
        }
        out[i] = parseInt(d);
    });
    return out;
}
function parseEmployeesData(empOrder, empData, unjoined) {
    let out = [];
    const joinedEmp = [];
    const unjoinedEmp = [];
    const empMap = new Map(empOrder?.map((val, idx) => [val, idx]));
    empData?.forEach(e => {
        const data = {
            id: e.ID,
            name: e.Name,
            joined: true,
            weekly: e.Week || 0,
            monthly: e.Month || 0,
        };
        joinedEmp.push(data);
    });
    unjoined?.forEach(e => {
        unjoinedEmp.push({
            id: e.ID,
            name: e.Name,
            joined: false,
            weekly: 0,
            monthly: 0,
        });
    });
    if (empOrder?.length > 0) {
        joinedEmp.sort((a, b) => (empMap.get(a.id) ?? Infinity) - (empMap.get(b.id) ?? Infinity));
    }
    out = [...joinedEmp, ...unjoinedEmp];
    return out;
}
function parseSection(rawSection) {
    return {
        id: rawSection.ID,
        name: rawSection.RoleName,
        purpose: rawSection.Purpose,
        color: rawSection.Color,
        from: rawSection.From,
        to: rawSection.To,
        isRest: rawSection.Rest,
        memo: rawSection.Memo,
        roleId: rawSection.RoleID
    };
}
function parseSections(rawSections) {
    if (!rawSections?.length) {
        return [];
    }
    return rawSections.map(parseSection);
}
